import React, { Component } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import Loader from '../common/loader';
import { makeAssetTypeTree } from './assetSelectors';
import TieredSelect from '../common/lookups/tieredSelect';
class AssetTypeFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const {
      assetType: {
        indexQuery
      },
      assetTypeActions: {
        serverIndex
      }
    } = this.props;
    serverIndex(indexQuery);
  }
  handleChange(selectedValues, newValue) {
    const {
      filters,
      onFilter
    } = this.props;
    const filterName = newValue.entity;
    if (filterName === 'assetCategoryName' || filterName === 'assetType') {
      let currentFilters = filters[filterName] ? filters[filterName] : [];
      if (currentFilters.some(at => at.id === newValue.id)) {
        // remove this from the list
        currentFilters = currentFilters.filter(at => at.id !== newValue.id);
      } else {
        const newFilter = {
          id: newValue.id,
          name: newValue.name
        };
        currentFilters = currentFilters.concat([newFilter]);
      }
      onFilter(filterName, currentFilters);
    }
  }
  render() {
    const {
      filters,
      isLoading,
      categoryTypeOptions,
      onBack
    } = this.props;
    let selections = [];
    if (filters) {
      if (filters.assetCategoryName) {
        selections = filters.assetCategoryName;
      }
      if (filters.assetType) {
        selections = selections.concat(filters.assetType);
      }
    }
    return /*#__PURE__*/React.createElement(TieredSelect, {
      style: {
        minHeight: 100
      },
      label: "Category / Type",
      data: categoryTypeOptions,
      value: selections,
      onBack: onBack,
      onChange: this.handleChange,
      backLabel: "Back"
    }, /*#__PURE__*/React.createElement(Loader, {
      loaded: !isLoading
    }));
  }
}
AssetTypeFilter.defaultProps = {
  filters: {}
};
AssetTypeFilter.propTypes = {
  filters: PropTypes.shape({
    assetCategoryName: PropTypes.string,
    assetType: PropTypes.string
  }),
  isLoading: PropTypes.bool.isRequired,
  assetType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  categoryTypeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onFilter: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};
export { AssetTypeFilter as TestAssetTypeFilter };
export default entityComposition(AssetTypeFilter, ['assetType'], {
  categoryTypeOptions: state => makeAssetTypeTree(state.assetType.list)
});